import gold from "../assets/images/opgg/testimonials/rank/gold.png"
import plat from "../assets/images/opgg/testimonials/rank/plat.png"
import diamond from "../assets/images/opgg/testimonials/rank/diamond.png"
import valorantPlat1 from "../assets/images/testimonial/rank/valorant_plat_1.png"
import valorantDiamond3 from "../assets/images/testimonial/rank/valorant_diamond_3.png"
import valorantGold3 from "../assets/images/testimonial/rank/valorant_gold_3.png"

import skfod from "../assets/images/conversion/testimonial/sk_fdo.png"
import thebean446 from "../assets/images/conversion/testimonial/thebean446.png"
import mario1x1 from "../assets/images/conversion/testimonial/mario1x1.png"
import crayonrus from "../assets/images/conversion/testimonial/crayonrus.png"
import bandito94 from "../assets/images/conversion/testimonial/bandito94.png"
import sumr97 from "../assets/images/conversion/testimonial/sumr97.png"
import ayeheychris2 from "../assets/images/conversion/testimonial/ayeheychris.png"
import shiyuflames2 from "../assets/images/conversion/testimonial/shiyuflames.png"
import djayjay2 from "../assets/images/conversion/testimonial/djayjay.png"

import aonly23 from "../assets/images/testimonial/aonly23.png"
import mcwhiskers from "../assets/images/testimonial/mcwhishkers.png"
import llamalover5 from "../assets/images/testimonial/llamalover5.png"

import swampy from "../assets/images/testimonial/swampy.png"
import mangocandy from "../assets/images/testimonial/mangocandy.png"
import morphet3 from "../assets/images/testimonial/morphet3.png"

import jarra from "@/assets/images/bootcamp/testimonial/jarra.png"

import carl from "@/assets/images/testimonial/carl-lomas.png"
import hayley from "@/assets/images/testimonial/hayley-emma-brooks.png"
import microflyz from "@/assets/images/testimonial/microflyz.png"
import mike from "@/assets/images/testimonial/mike.png"
import pdiddz from "@/assets/images/testimonial/pdiddz.png"
import young from "@/assets/images/testimonial/young-dalliance.png"
import timeless from "@/assets/images/testimonial/timeless.png"

const LEAGUE_CONVERSION_TESTIMONIALS = [
  {
    name: "SK FOD",
    avatar: skfod,
    rankImg: plat,
    before: "Silver I",
    after: "Platinum IV",
    comment:
      "I didn't think ProGuides would work. I was wrong. It works, and it's the fastest way i've ever ranked up.",
  },
  {
    name: "TheBean446",
    avatar: thebean446,
    rankImg: gold,
    before: "Bronze III",
    after: "Gold III",
    comment:
      "I was aiming for silver by the end of season but I'm already in Gold and I think I can actually hit Platinum. 100% recommend.",
  },
  {
    name: "Mario1X1",
    avatar: mario1x1,
    rankImg: diamond,
    before: "Gold I",
    after: "Diamond IV",
    comment:
      "I joined ProGuides 1 month ago and I've been playing league for over 6 years. I can't believe that just playing with right pro can take you this far. I got a session immediately after joining.",
  },
  {
    name: "CrayonRus",
    avatar: crayonrus,
    rankImg: plat,
    before: "Silver IV",
    after: "Platinum IV",
    comment:
      "I was sick of losing. I would go on huge loss streaks, and ended every season stuck at the same rank. ProGuides taught me to take control of my games. It feels great to be confident again.",
  },
  {
    name: "Bandito94",
    avatar: bandito94,
    rankImg: diamond,
    before: "Gold II",
    after: "Diamond I",
    comment:
      "Thinking bout how I used to think about League makes my soul hurt lol. ProGuides helped me focus my energy and time, idk wtf I was doing before.",
  },
  {
    name: "Sumr97",
    avatar: sumr97,
    rankImg: plat,
    before: "Silver II",
    after: "Platinum I",
    comment:
      "My friends are still in Silver asking ME for help, and all I can recommend is ProGuides. I wasn't progressing before, and now I know how/what to practice.",
  },
  {
    name: "AyeHeyChris",
    avatar: ayeheychris2,
    rankImg: plat,
    before: "Silver I",
    after: "Platinum III",
    comment:
      "Shout out to my coach for not giving up on me. I was trash in my group cus my friends all played for years but LOOK WHO'S PLATINUM NOW!!! leskeddit.",
  },
  {
    name: "ShiYuFlames",
    avatar: shiyuflames2,
    rankImg: diamond,
    before: "Gold II",
    after: "Diamond III",
    comment:
      "For years all I wanted was to git gud (lol) but all I did about it was spend hours on Youtube. Glad I found ProGuides and especially my coach.",
  },
  {
    name: "DJayJay",
    avatar: djayjay2,
    rankImg: gold,
    before: "Bronze III",
    after: "Gold I",
    comment:
      "I don't think I ever want to grind without a ProGuides coach again. That was absolute hell and I nearly quit 3 times. Never again.",
  },
]

const FORTNITE_CONVERSION_TESTIMONIALS = [
  {
    name: "Aonly23",
    avatar: aonly23,
    rankImg: "",
    before: "Arena 6",
    after: "Arena 10 (Champions)",
    comment:
      "Being able to experience playing with a pro player who is also a world class coach took me to a whole new level. I definitely recommend joining to anyone who's serious about getting better fast.",
  },
  {
    name: "McWhiskers",
    avatar: mcwhiskers,
    rankImg: "",
    before: "Arena 1",
    after: "Arena 7 (Champions)",
    comment:
      "I tried ProGuides to see if they can help me stop being a noob at Fortnite and I'm absolutely blown away. The improvement that usually takes months to achieve happened in a few weeks and I already hit contender division 7 after training with my coach.",
  },
  {
    name: "llamalover5",
    avatar: llamalover5,
    rankImg: "",
    before: "Arena 5",
    after: "Arena 9 (Champions)",
    comment:
      "I've been stuck in contender division for weeks even though I've been grinding everyday. After finally becoming a pro member I hit champions league. ProGuides has taken me to new levels. I'm now really good at decision making and building.",
  },
]
const VALORANT_CONVERSION_TESTIMONIALS = [
  {
    name: "Swampy",
    avatar: swampy,
    rankImg: valorantPlat1,
    before: "Silver 2",
    after: "Platinum 1",
    comment:
      " When I started Valorant I was able to get to Silver 2 all on my own, but got stuck. I stumbled upon ProGuides, and after 1 month of using their services I've already hit platinum. It just works.",
  },
  {
    name: "MaNgocandy",
    avatar: mangocandy,
    rankImg: valorantDiamond3,
    before: "Platinum 2",
    after: "Diamond 3",
    comment:
      "There are a million different things that you have to master in order to reach the top level. And the people at the top don't spill their secrets. Having access to top 1% coaches took me to a new level.",
  },
  {
    name: "Morphet3",
    avatar: morphet3,
    rankImg: valorantGold3,
    before: "Iron 1",
    after: "Gold 2",
    comment:
      "Valorant is one of my favorite games, but it's also one of my worst. No matter what I did I was still stuck in Iron. That all changed when I tried ProGuides. Just hit Gold 2 and going for Platinum next!",
  },
]

export const CONVERSION_TESTIMONIALS = {
  leagueoflegends: LEAGUE_CONVERSION_TESTIMONIALS,
  fortnite: FORTNITE_CONVERSION_TESTIMONIALS,
  valorant: VALORANT_CONVERSION_TESTIMONIALS,
}

export const TESTIMONIALS_V3 = [
  {
    username: "Carl Lomas",
    title: "My son used a trainer today (Callum)...",
    description:
      "My son used a trainer today (Callun) and he learned so much with u expect but my son was so happy and calm really enjoyed his company and learned so much in small tips why they played duos together. Will be pushing again DEFINITELY",
    avatar: carl,
  },
  {
    username: "Young Dalliance",
    title: "Level up my gameplay.",
    avatar: young,
    description:
      "I consider my self a fairly inexperienced player and the coaches ProGuides, have completely helped me level up my gameplay. Wether it be mindset, game mechanics , or troubleshooting my gameplay. I feel ProGuides and my coach, have given me a competitive edge in my lobbies!",
  },

  {
    username: "Hayley Emma Brooks",
    title: "Amazing time!",
    avatar: hayley,
    description:
      "My son had a coaching session and it was first class. Very professional but also very engaging with the player. Will definitely be doing more! This has made his day!!",
  },
  {
    username: "PDiddz",
    title: "I would recommend this service to anyone!",
    avatar: pdiddz,
    description:
      "My experience with ProGuides was amazing, I was helped with everything that I asked for such as movement, gunskill, and more! In the end the site made me feel much more confident in my games and helped me improve immensely! I would recommend this service to anyone!",
  },
  {
    username: "Mike",
    title: "Amazing Service",
    avatar: mike,
    description:
      "I strongly recommend proguides. It helps connect coaches and players and is a great community of people. Every coaching session I have had has helped me improve overall and I would strongly recommend this to anyone looking to improve.",
  },
  {
    username: "MicroFlyz",
    title: "Finally!",
    avatar: microflyz,
    description:
      "I was playing Apex for a few months, and felt lost. I wasn't getting better, and found myself hard stuck in gold. After finding ProGuides, they helped me find the big mistakes I was making, and showed me multiple ways to improve them, fast. After 2 months with ProGuides, I finally reached Diamond 4",
  },
]

export const TESTIMONIALS_V4 = [
  {
    username: "Dalin Pratt",
    title: "Good, friendly coaches with personalized guidance",
    description:
      "I received coaching for both League of Legends and for Rocket League, the coaches are all very friendly and provide great personalized feedback both during and after a session. They are very flexible in teaching what you want or need to learn as well as how a session goes.",
    avatar: carl,
    url: "https://www.trustpilot.com/users/6185b6084b1a7b0012be8f75",
  },
  {
    username: "Aleena Stamness",
    title: "I had a fantastic coaching session!",
    avatar: pdiddz,
    url: "https://www.trustpilot.com/reviews/616dc1a675069a4da488effd",
    description:
      "I had a fantastic coaching session! Learned a lot of skills I could improve on and got great feedback. I also love their guides on YouTube, I was able to improve on my own before booking a session!",
  },
  {
    username: "evan konopackie",
    title: "I would 100% recommend using pro guides",
    avatar: hayley,
    url: "https://www.trustpilot.com/reviews/61671614234f1b1fe5592633",
    description:
      "I would 100% recommend using pro guides if improving your game is important to you. All of the coach's I've been trained by on pro guides have been very nice and most importantly helpful.",
  },
  {
    username: "Timeless Dbz",
    title: "Proguides is straight forward",
    avatar: timeless,
    url: "https://www.trustpilot.com/reviews/61639a7cb873f1f75f5c3dab",
    description:
      "Proguides is straight forward. The coaches are very informative and helpful. If you are striving to get better at your game defiantly book a session with a coach.",
  },
]

export const TESTIMONIALS_V5 = [
  {
    username: "Tevon Ulett",
    title: "Great Coach",
    description:
      "the session was really great and informative, every time he saw a mistake he was sure to point it out and he was patient whenever I didn't seem to understand, but went through step by step until I could grasp the information. Great coach",
    avatar: swampy,
    url: "https://www.trustpilot.com/reviews/615bbeb6d879345cc7ba3991",
  },
  {
    username: "aaron powell",
    title: "Pro guides has done alot for my gaming",
    avatar: mangocandy,
    description:
      "Pro guides has done alot for my gaming experience in multiple games. I have used them for csgo, valorant, and LOL. It has helped me be more competitive and grow as a gamer.",
    url: "https://www.trustpilot.com/reviews/6158eb886223e22118c1277c",
  },
  {
    username: "Mike",
    title: "Amazing Service",
    avatar: morphet3,
    url: "https://www.trustpilot.com/reviews/612c4f37cc0087e8ef68ba5e",
    description:
      "I strongly recommend proguides. It helps connect coaches and players and is a great community of people. Every coaching session I have had has helped me improve overall and I would strongly recommend this to anyone looking to improve.",
  },
  {
    username: "Ultranite",
    url: "https://www.trustpilot.com/reviews/6109e505f9f48709d4c7545b",
    title: "The site is very well made and easy to",
    avatar: jarra,
    description:
      "The site is very well made and easy to navigate. All of my experiences with the coaches have been exceptional and I enjoyed the sessions.",
  },
]



// WEBPACK FOOTER //
// ./src/constants/testimonials.js